
import React, { useEffect } from "react";
import "./GenericDrawerComp.css";

const GenericDrawerComp = ({
  open = false,
  disableXbtn = false,
  onClose,
  children,
  titleForSideCard,
  minWidthForDrawer = "50%",
}) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [open]);

  return (
    <>
     {open && <div
        className={`offcanvas offcanvas-end custom-drawer p-0 ${
          open ? "open" : "closed"
        }`}
        style={{
          minWidth: minWidthForDrawer,
          visibility: open ? "visible" : "hidden",
        }}
      >
        {titleForSideCard && (
          <div className="generic-sideCardHeader">
            <h5 className="offcanvas-title">{titleForSideCard}</h5>
            {!disableXbtn && (
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            )}
          </div>
        )}
        <div className="sideCardBody">{children}</div>
      </div>}

      {open && (
        <div
          className="offcanvas-backdrop fade show"
          style={{ opacity: 0.3, transition: "opacity 0.15s linear" }}
          onClick={onClose}
        />
      )}
    </>
  );
};

export default GenericDrawerComp;
